import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import Link from 'flarum/common/components/Link';
export default class VotesModal extends Modal {
  className() {
    return 'VotesModal Modal--small';
  }
  title() {
    return app.translator.trans('fof-gamification.forum.modal.title');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = !this.attrs.post.upvotes() || !this.attrs.post.downvotes();
    if (this.loading) {
      this.load();
    }
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "Modal-body"
    }, m("ul", {
      className: "VotesModal-list"
    }, ['upvotes', 'downvotes'].map(type => {
      const voters = this.attrs.post[type]();
      if (!voters || !voters.length) return;
      return m("div", null, m("legend", null, app.translator.trans("fof-gamification.forum.modal.".concat(type, "_label"))), voters.map(user => m("li", null, m(Link, {
        href: app.route.user(user)
      }, m(Avatar, {
        user: user
      }), " ", username(user)))));
    })));
  }
  load() {
    return app.store.find('posts', this.attrs.post.id(), {
      include: 'upvotes,downvotes'
    }).then(this.loaded.bind(this));
  }
}
flarum.reg.add('fof-gamification', 'forum/components/VotesModal', VotesModal);